import { render } from "./PreFooterContainer.vue?vue&type=template&id=7db44866"
import script from "./PreFooterContainer.vue?vue&type=script&lang=js"
export * from "./PreFooterContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__